import {PostFiveStars} from 'domain/usecases';
import {RemotePostFiveStars} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {FiveStarsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostFiveStars = (): PostFiveStars =>
	new RemotePostFiveStars(
		makeBFFApiUrl(FiveStarsFlowEndPoints.fiveStarsFlow),
		makeAuthorizeHttpClientDecorator(),
	);
